import { render, staticRenderFns } from "./AppointList.vue?vue&type=template&id=27edea39&scoped=true&"
import script from "./AppointList.vue?vue&type=script&lang=js&"
export * from "./AppointList.vue?vue&type=script&lang=js&"
import style0 from "./AppointList.vue?vue&type=style&index=0&id=27edea39&lang=less&scoped=true&"
import style1 from "./AppointList.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27edea39",
  null
  
)

export default component.exports